import React from "react";

import { Helmet } from "react-helmet";

import { Routes, Route, Navigate } from "react-router-dom";

import { createUseStyles } from "react-jss";

import { dashRoutes as routes } from "routes.js";

import AuthNavbar from "components/Navigation/Navbars/Auth/AuthNavbar";
import Footer from "components/Sales/Footer";
import styles from "assets/jss/material-dashboard-pro-react/layouts/authStyle.js";

const useStyles = createUseStyles(styles);

export default function Pages(props) {
  const classes = useStyles();
  const { setMasterAlert, ...rest } = props;
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/auth") {
        if (prop.path === "/") {
          return (
            <Route
              path={prop.path}
              key={key}
              // element={(props) => (
              //   <prop.component {...props} setMasterAlert={setMasterAlert} />
              // )}
              element={<prop.component setMasterAlert={setMasterAlert} />}
            />
          );
        }
        return (
          <Route
            path={prop.layout + prop.path}
            element={<prop.component setMasterAlert={setMasterAlert} />}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <div className={classes.wrapper}>
      <Helmet>
        <title>Stakeholder Mapping and Analysis</title>
        <meta
          name="description"
          content="Stakeholders.app | Stakeholder Mapping and Analysis Platform"
        />
      </Helmet>
      <div className={classes.fullPage}>
        <AuthNavbar {...rest} shrinkOnValue={500} />
        <Routes>
          {getRoutes(routes)}
          <Route path="/*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
      </div>
    </div>
  );
}
